import { render, staticRenderFns } from "./notesSettings.vue?vue&type=template&id=4beb5252&scoped=true"
import script from "./notesSettings.vue?vue&type=script&lang=js"
export * from "./notesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beb5252",
  null
  
)

export default component.exports